import { type UseModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Skeleton, Stack } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib";
import { useCreateOrGetPlacementCandidate } from "@src/appV2/redesign/PlacementCandidate/api/useCreateOrGetPlacementCandidate";
import { type WorkplaceProfile } from "@src/appV2/redesign/Workplace/types";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useTrackMarketingLinkClicks } from "../../PlacementCandidate/hooks/useTrackMarketingLinkClicks";
import { WorkplacePlacements } from "./WorkplacePlacements";

interface WorkplaceJobsProps {
  workplaceId: string;
  isLoading?: boolean;
  workplace?: WorkplaceProfile;
  modalState: UseModalState;
}

export function WorkplacePlacementsModal(props: WorkplaceJobsProps) {
  const { workplaceId, isLoading, modalState, workplace } = props;

  const worker = useDefinedWorker();

  const {
    data: placementCandidate,
    isLoading: isPlacementCandidateLoading,
    isSuccess: isPlacementCandidateSuccess,
  } = useCreateOrGetPlacementCandidate(
    { workerId: worker.userId },
    { enabled: isDefined(worker.userId) }
  );

  useTrackMarketingLinkClicks({
    placementCandidate,
    workplaceId,
    enabled: isDefined(placementCandidate),
  });

  const isLoadingAnything = isPlacementCandidateLoading || isLoading;

  if (!isLoadingAnything && isPlacementCandidateSuccess) {
    return (
      <FullScreenDialog skipTopSafeAreaPadding modalState={modalState} variant="tertiary">
        <WorkplacePlacements
          workplaceId={workplaceId}
          workplace={workplace}
          modalState={modalState}
          placementCandidate={placementCandidate}
        />
      </FullScreenDialog>
    );
  }

  return (
    <FullScreenDialog skipTopSafeAreaPadding modalState={modalState} variant="primary">
      <Stack spacing={6}>
        <Stack>
          <Skeleton width="100%" height="56px" />
          <Skeleton width="80%" height="32px" />
        </Stack>
        <Stack spacing={4}>
          <Skeleton width="100%" height="48px" sx={{ transform: "none" }} />
          <Skeleton width="100%" height="48px" sx={{ transform: "none" }} />
        </Stack>
      </Stack>
    </FullScreenDialog>
  );
}
